<template>
  <div class="content">
    <column-title title="Members"></column-title>
    <div class="group-title">Principal Investigator</div>
    <div class="info">
      <img class="photo" :src="WeiChen">
      <div class="column">
        <span class="row name">Wei Chen</span>
        <span class="row name-cn">陈维</span>
        <a href="mailto:weichen1@ustc.edu.cn" class="row">weichen1@ustc.edu.cn</a>
        <a href="https://scholar.google.com/citations?hl=en&user=8QDJgikAAAAJ"
           target="_blank" class="row">Google Scholar</a>
        <a class="row" href="http://applchem.ustc.edu.cn/2018/0607/c15402a388964/page.htm" target="_blank">
          Department of Applied Chemistry Page
        </a>
        <a class="row" href="http://www.hfnl.ustc.edu.cn/detail?id=16124" target="_blank">
          Hefei National Laboratory for Physical Sciences at the Microscale Page
        </a>
        <table class="time-table">
        <tr
            v-for="(activity, index) in timeline"
            :key="index">
          <td>{{ activity.content }}</td><td>{{activity.time}}</td>
        </tr></table>
      </div>
    </div>
    <div class="group-title">Postdocs</div>
    <template v-for="(member,index) in postdocs" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <div class="group-title">Ph.D. Students</div>
    <template v-for="(member,index) in phDStudents" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <div class="group-title">M.S. Students</div>
    <template v-for="(member,index) in mSStudent" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <div class="group-title">Undergraduates</div>
    <template v-for="(member,index) in undergraduate" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <div class="group-title">Visiting Scholars</div>
    <template v-for="(member,index) in visitingScholar" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <div class="group-title">Alumni</div>
    <template v-for="(member,index) in alumni" :key="index">
      <MemberInfo v-bind="member"></MemberInfo>
    </template>
    <el-backtop target=".scrollbar .el-scrollbar__wrap" bottom="200"></el-backtop>
  </div>
</template>

<script>

import WeiChen from '@/assets/images/Dr.Wei Chen.jpg'
import members from "@/assets/data/members";
import ColumnTitle from "@/components/ColumnTitle";
import MemberInfo from "@/components/MemberInfo";


export default {
  name: "Publications",
  components: {
    MemberInfo,
    ColumnTitle,
  },
  data() {
    return {
      members,
      WeiChen,
      timeline: [
        {
          content: 'Professor, Dept. of Applied Chemistry, USTC',
          time: 'Jul.2019-'
        }, {
          content: 'Scientist, EEnotech',
          time: 'Jun.2018-Jun.2019'
        }, {
          content: 'Postdoc, Stanford University',
          time: 'Apr.2014-May2018'
        },
        {
          content: 'Ph.D., King Abdullah Univ. of Sci.&Tech.',
          time: 'Jan.2011-Dec.2013'
        },
        {
          content: 'M.S., King Abdullah Univ. of Sci.&Tech.',
          time: 'Sept.2009-Dec.2010'
        },
        {
          content: 'B.S., Univ. of Sci.&Tech. Beijing',
          time: 'Sept.2004-Jun.2008'
        },]
    }
  },
  computed: {
    postdocs() {
      return this.members.filter(member => member.identity === 'Postdoc')
    },
    phDStudents() {
      return this.members.filter(member => member.identity === 'Ph.D. Student')
    },
    mSStudent() {
      return this.members.filter(member => member.identity === 'M.S. Student')
    },
    undergraduate() {
      return this.members.filter(member => member.identity === 'Undergraduate')
    },
    visitingScholar() {
      return this.members.filter(member => member.identity === 'Visiting Scholar')
    },
    alumni() {
      return this.members.filter(member => member.identity === 'Alumni')
    }
  },
  methods: {
    showYear(year) {
      if (year !== this.year) {
        this.year = year
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}

.group-title {
  color: dodgerblue;
  font-size: 18px;
  font-weight: bold;
}

.info {
  margin: 16px;
  display: flex;
}

.photo {
  margin-right: 16px;
  width: 300px;
  height: 375px
}

a {
  color: dodgerblue;
}

.column {
  display: inline-flex;
  flex-direction: column;
}

.row {
  display: block;
}

.time-table{
  margin-top: 32px;
}

.name{
  font-weight: bold;
  font-size: 20px;
}

.name-cn{
  font-size: 20px;
}



</style>